export default function viewToViewValidity() {
  const createViewVlidity = (view) => {
    let viewValidity = new Object();
    for (let key in view) {
      const originValue = view[key];
      if (!Array.isArray(originValue)) {
        if (originValue === null || typeof originValue !== "object") {
          viewValidity[key] = { isValid: true, msg: "" };
        } else {
          viewValidity[key] = createViewVlidity(originValue);
        }
      } else {
        let mappedArray = [];
        for (let item of originValue) {
          if (item !== null && typeof item === "object") {
            mappedArray.push(createViewVlidity(item));
          } else {
            mappedArray.push({ isValid: true, msg: "" });
          }
        }
        viewValidity[key] = mappedArray;
      }
    }
    return viewValidity;
  };

  return createViewVlidity;
}
